<template>
  <div id="hortense-about">
    <section
      class="banner"
      :style="{ backgroundImage: 'url(' + activeTab.image + ')' }"
      role="img"
      aria-label="Page banner"
    >
      <div class="overlay">
        <h1>{{ activeTab.title }}</h1>
      </div>
    </section>
    <nav class="tabs" aria-label="Navigation des sections Hortense">
      <ul>
        <li
          v-for="tab in tabs"
          :key="tab.id"
          style="font: normal normal bold 15px/18px Raleway;"
          class="tab-item"
          :class="{ active: activeTab.id === tab.id }"
          @click="switchTab(tab)"
        >
          {{ tab.label }}
        </li>
      </ul>
    </nav>
    <section class="content">
      <div v-if="activeTab.id === 'qui'">
        <div class="intro" style="max-width: 1200px  !important; margin: 70px auto !important; padding: 0 20px  !important;">
          <div class="ma-header">
            <h2 class="kicker" :class="isMobile ? 'merriweather-reg-20' : 'merriweather-reg-26'">Une nouvelle manière</h2>
            <h3 class="title" :class="isMobile ? 'merriweather-reg-26' : 'merriweather-reg-40'">de découvrir le monde</h3>
          </div>

          <div class="text-image mt-3">
            <img
              class="media"
              src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Photo_qui_est_hortense.webp"
              alt="Piscine d'un hébergement de charme"
            />
            <div class="text">
              <p>
                Vous faire vivre des séjours dans des lieux d’exception, où se conjuguent charme,
                authenticité et confort haut de gamme, en parfaite harmonie avec la nature :
                c’est la promesse d’Hortense, plateforme de réservation d’hébergements de charme
                éco-responsables.
              </p>
              <p>
                Grâce à une sélection exigeante de maisons d’hôtes, d’hôtels confidentiels et de
                refuges inspirants, Hortense révèle des adresses uniques, portées par des hôtes
                engagés, véritables artisans.
              </p>
              <p>
                Partir, c’est s’ouvrir. Mais aujourd’hui, voyager, c’est aussi repenser nos habitudes,
                prendre le temps de choisir des lieux qui partagent nos valeurs, et s’offrir des
                expériences sincères, responsables, inoubliables…
              </p>
              <p>
                Hortense accompagne cette transition vers un tourisme plus vertueux en mettant en lumière
                des établissements engagés, chaleureux, à taille humaine. Chaque lieu que nous sélectionnons
                raconte une histoire, celle d’un territoire, d’un savoir-faire, d’une passion et d’un
                engagement fort envers la planète.
              </p>
            </div>
          </div>
        </div>
        <div style="background-color: #CFE5DC33; width: 100vw !important; padding: 0 !important; margin: 0 !important;">
        <div class="mv-grid mt-3 pt-3" >
          <section class="block">
            <h2 style="font: normal normal normal 32px/40px Merriweather;">Notre mission</h2>
            <div class="cards">
              <article class="card">
                <img
                  src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Rendre+visible+l'invisible.webp"
                  alt="Cabane dans la forêt"
                />
                <h3>RENDRE VISIBLE L’INVISIBLE</h3>
                <p>
                  Nous croyons que la transparence est essentielle. Hortense donne aux voyageurs les clés pour comprendre l’engagement écologique des lieux qui choisissent. Grâce à notre outil de scoring, chaque hébergement rend visible son impact environnemental, pour permettre des choix éclairés.
                </p>
              </article>

              <article class="card">
                <img
                  src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Accompagner+les+lieux+dans+leur+transition.webp"
                  alt="Patio élégant"
                />
                <h3>ACCOMPAGNER LES LIEUX DANS LEUR TRANSITION</h3>
                <p>
                   Au-delà de la sélection, nous agissons aux côtés de nos partenaires. Nous les aidons à mettre en place des pratiques écoresponsables, à se former, à sensibiliser leurs équipes et leurs hôtes, et à investir dans des projets concrets grâce à notre programme Evergreen.
                </p>
              </article>
            </div>
          </section>

          <section class="block">
            <h2 style="font: normal normal normal 32px/40px Merriweather;">Nos valeurs</h2>
            <div class="cards">
              <article class="card">
                <img
                  src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Le+gou%CC%82t+du+beau+et+du+vrai.webp"
                  alt="Fenêtre ouverte vers la mer"
                />
                <h3>LE GOÛT DU BEAU ET DU VRAI</h3>
                <p>
                   Chez Hortense, nous avons un faible pour les lieux qui ont une âme, une signature, un supplément d’âme que l’on ne trouve nulle part ailleurs. C’est dans cette alliance subtile entre l’excellence du service et le respect de la nature que se niche l’essence d’Hortense.
                </p>
              </article>


              <article class="card">
                <img
                  src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/L'engagement+a%CC%80+chaque+e%CC%81tape.webp"
                  alt="Rivière et végétation"
                />
                <h3>L’ENGAGEMENT À CHAQUE ÉTAPE</h3>
                <p>
                   Tous nos partenaires partagent une même volonté : diminuer leur empreinte carbone, protéger les ressources naturelles, favoriser les circuits courts et réenchanter l’accueil à travers une hospitalité sincère et durable.
                </p>
              </article>
            </div>
          </section>
        </div>
      </div>
      <div class="cta-center">
          <a class="btn-primary" href="/le-mot-de-la-fondatrice">
            LE MOT DE LA FONDATRICE
          </a>
        </div>
      </div>

      <div v-else-if="activeTab.id === 'fondatrice'">
        <section class="founder-essay" style="background-color: #CFE5DC33;">
          <p>
            Il y a des projets qui ne se choisissent pas. Ils s’imposent à vous comme une évidence. Hortense.green fait partie de ceux-là. Il est né de ma volonté de donner du sens à mon travail et de développer un projet en accord avec mes valeurs, en réunissant mes intérêts pour le voyage, l’hôtellerie de luxe et le développement durable.
          </p>
          <p>
            Diplômée en finance de l’Université Paris-Dauphine, j’ai travaillé pendant huit ans dans ce secteur, aux côtés d’entrepreneurs et de dirigeants d’entreprise inspirants. Une école de rigueur et d’exigence qui m’a profondément marquée. Mais au fil du temps, le besoin d’aligner mes valeurs personnelles avec mon quotidien professionnel est devenu une évidence. J’ai eu envie, à mon tour, de créer une entreprise en partant d’une feuille blanche, et d’imaginer une autre façon de voyager : découvrir de beaux endroits, profiter d’un certain confort, tout en respectant pleinement l’environnement.
          </p>
          <p>
            Je suis convaincue que le luxe n’a de sens que s’il est porteur d’équilibre. Un équilibre subtil entre beauté et sobriété, entre plaisir et responsabilité, entre l’humain et la nature. Pour moi, Hortense.green n’est pas une simple collection d’hébergements de charme. C’est une vision. Celle d’un tourisme réinventé, plus durable, respectueux de l’environnement, fondé sur la rencontre, la découverte locale et le partage.
          </p>
          <p>
            Avec Hortense.green, j’ai voulu bâtir un pont entre deux mondes : celui de l’excellence et celui
            de la conscience. Offrir aux voyageurs en quête d’authenticité des lieux d’exception, où l’art de
            recevoir rime avec respect de l’environnement, valorisation des savoir-faire locaux et transmission
            aux générations futures.
          </p>
          <p>
            Avec Hortense.green, j’ai voulu bâtir un pont entre deux mondes : celui de l’excellence et celui de la conscience. Offrir aux voyageurs en quête d’authenticité des lieux d’exception, où l’art de recevoir rime avec respect de l’environnement, valorisation des savoir-faire locaux et transmission aux générations futures.
          </p>
          <p>
            Notre démarche est exigeante. Chaque adresse est évaluée à travers <strong>la Green Note</strong>, un modèle de scoring environnemental que j’ai créé, fondé sur plus de 150 critères de durabilité. 
          </p>
          <p>
            Nous soutenons également des projets écologiques concrets à travers notre <strong>programme Evergreen</strong>, et nous cultivons l’art de recevoir, en offrant à nos membres les privilèges exclusifs du <strong>Club Hortense</strong>.
          </p>
          <p>
            de voyageurs engagés, d’hôtes inspirants et de professionnels passionnés. Ensemble, nous façonnons un nouveau luxe : plus sobre, plus sensible, plus aligné avec les défis de notre époque.
          </p>
          <p>
            Aujourd’hui, voyager n’est plus un simple déplacement. C’est un acte, un choix, une responsabilité. Et c’est, plus que jamais, une invitation à la découverte, à la rencontre, à l’échange et au partage.
          </p>
          <div class="founder-quote">
          <div class="quote-wrap">
            <blockquote style="font: italic normal 300 15px/35px Merriweather;">
              “Je vous remercie de faire partie de cette aventure.<br />
              Merci de croire, vous aussi, qu’il est possible d’explorer le monde tout en respectant la planète.<br />
              Merci de choisir une hospitalité qui a du cœur et du sens.<br />
              Merci de contribuer, avec nous, à faire d’Hortense la référence du tourisme haut de gamme et éco-responsable.”<br/>
              “N’arrêtons pas de voyager mais voyageons mieux !”
            </blockquote>

            <div class="signature">
              <div class="name">Aurore Sterling</div>
              <div class="role">Fondatrice de Hortense.green</div>
            </div>
          </div>

          <div class="founder-photo">
            <img
              src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Aurore-Sterling-Photo-mot-de-la-fondatrice.webp"
              alt="Portrait de la fondatrice"
            />
          </div>
        </div>
        </section>

        <div class="cta-center">
          <a class="btn-primary" href="#club-hortense" @click.prevent="switchTabById('club')">
            LE CLUB HORTENSE
          </a>
        </div>
      </div>

      <HortensioTwo v-else-if="activeTab.id === 'club'" :user="user" />

      <div v-else-if="activeTab.id === 'green'">
        <section class="gn-intro text-center">
          <h2 class="text-center" :class="isMobile ? 'merriweather-reg-20' : 'merriweather-reg-26'">
            Qu’est-ce que<br />
            <span class="text-center" :class="isMobile ? 'merriweather-reg-26' : 'merriweather-reg-40'">la Green Note ?</span>
          </h2>
          <p class="lead">
            C’est un <em>outil de scoring environnemental</em> conçu par Hortense pour donner du sens au mot « éco-responsable ».
            Il permet de mesurer l’engagement durable des hébergements à travers <strong>10 critères fondamentaux</strong> et
            <strong>150 indicateurs concrets</strong>. Chaque hébergement se voit attribuer un <strong>score de 1 à 10</strong>,
            à la fois par critère et de manière globale. C’est une <em>boussole</em> : elle éclaire les voyageurs, valorise les
            efforts sincères et accompagne les professionnels dans leur transformation.
          </p>
        </section>

        <section class="gn-ambition">
          <div class="ambition-inner">
            <div class="gn-logo" aria-hidden="true">
              <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Logo_green_note.png"/>
            </div>

            <div class="ambition-copy">
              <h3 class="text-center" :class="isMobile ? 'merriweather-reg-20' : 'merriweather-reg-26'">Notre ambition<br /><span class="text-center" :class="isMobile ? 'merriweather-reg-26' : 'merriweather-reg-40'">avec la Green Note</span></h3>
              <p>
                Stimuler la performance environnementale et économique du secteur en accompagnant
                les acteurs vers des modèles plus vertueux et résilients. Pour y parvenir, il est
                essentiel de leur offrir des outils concrets et techniques, adaptés aux réalités
                du terrain, afin de faciliter la mise en œuvre de pratiques durables. Enfin, partager la connaissance et diffuser les bonnes pratiques constitue un levier
                majeur pour accélérer la transition écologique du tourisme et favoriser une montée
                en compétence collective.
              </p>
            </div>
          </div>
        </section>

        <section class="gn-how">
          <h3 class="text-center" :class="isMobile ? 'merriweather-reg-20' : 'merriweather-reg-26'">Comment<br /><span class="text-center" :class="isMobile ? 'merriweather-reg-26' : 'merriweather-reg-40'">ça fonctionne ?</span></h3>
          <p class="how-lead" style="font: normal normal normal 15px/24px Raleway;">
            Chaque hébergement est évalué selon une grille précise de critères, couvrant l’ensemble
            des pratiques durables. Chaque critère est noté sur 10. Ces notes sont ensuite pondérées
            et agrégées pour former une moyenne générale — la Green Note globale, de 1 à 10.
            Seuls les hébergements obtenant une note minimale de 5/10 peuvent intégrer la sélection
            Hortense. Ce seuil garantit un niveau d’engagement cohérent avec notre charte, tout en
            valorisant les efforts progressifs et les démarches sincères.
          </p>

          <div class="gn-accordion">
            <h4 class="acc-title">Les 10 critères de la Green Note</h4>

            <div
              v-for="(item, idx) in criteria"
              :key="item.title"
              class="acc-item"
            >
              <button class="acc-head" @click="toggleAcc(idx)">
                <span class="raleway-semi-p15">{{ item.title }}</span>
                <svg
                  :class="{ open: openAcc.includes(idx) }"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    d="M7 10l5 5 5-5"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>

              <transition name="acc">
                <div v-show="openAcc.includes(idx)" class="acc-panel">
                  <ul class="raleway-reg-p15">
                    <li v-for="(line, i) in item.points" :key="i">{{ line }}</li>
                  </ul>
                </div>
              </transition>
            </div>
          </div>

          <p class="how-foot">
            La Green Note évolue chaque année, pour refléter les progrès continus des hébergements.
            Nous proposons un accompagnement personnalisé incluant un outil de plan d’action
            structurant, des conseils techniques et pragmatiques et un suivi de long terme.
            En plus d’une commission ajustée selon l’engagement, la Green Note est aussi un
            levier économique : plus un hébergement est engagé, plus son taux de commission
            baisse. Un système équitable et motivant, fondé sur des critères objectifs,
            pour récompenser les efforts sincères.
          </p>
        </section>

        <section class="gn-levels">
          <h3 class="text-center levels-title" :class="isMobile ? 'merriweather-reg-26' : 'merriweather-reg-32'">Les 4 niveaux d’engagement Green Note</h3>

          <div class="levels-track" aria-hidden="true">
            <div class="pins">
              <span class="pin">
                <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Mention_convenable_green_note.png"/>
              </span>
              <span class="pin">
                <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Mention_honorable_green_note.png"/>
              </span>
              <span class="pin">
                <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Mention_remarquable_green_note.png"/>
              </span>
              <span class="pin">
                <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Mention_exemplaire_green_note.png"/>
              </span>
            </div>
            <div class="track-line"></div>
          </div>

          <div class="levels-grid">
            <div class="level-col">
              <div class="pill pill-top tone-1">
                <div class="pill-inner pilll">
                  <strong>De 4 à 5</strong><br />
                  Mention Convenable
                </div>
              </div>
              <div class="pill pill-bottom">
                <div class="pill-inner tone-1">
                  L’hébergement débute sa transition. Il a engagé des premières actions
                  mais dispose encore d’un large potentiel d’amélioration.
                </div>
              </div>
            </div>

            <div class="level-col">
              <div class="pill pill-top tone-2">
                <div class="pill-inner pilll">
                  <strong>De 6 à 7</strong><br />
                  Mention Honorable
                </div>
              </div>
              <div class="pill pill-bottom">
                <div class="pill-inner tone-2">
                  Un bon niveau d’engagement est en place. L’impact est réel, mais
                  certaines pratiques peuvent encore être renforcées.
                </div>
              </div>
            </div>

            <div class="level-col">
              <div class="pill pill-top tone-3">
                <div class="pill-inner pilll">
                  <strong>De 7 à 8</strong><br />
                  Mention Remarquable
                </div>
              </div>
              <div class="pill pill-bottom">
                <div class="pill-inner tone-3">
                  La gestion durable fait partie intégrante du fonctionnement.
                  L’établissement agit avec cohérence et constance.
                </div>
              </div>
            </div>

            <div class="level-col">
              <div class="pill pill-top tone-4">
                <div class="pill-inner pilll">
                  <strong>De 8 à 10</strong><br />
                  Mention Exemplaire
                </div>
              </div>
              <div class="pill pill-bottom">
                <div class="pill-inner tone-4">
                  Un modèle d’inspiration. L’impact environnemental est extrêmement
                  faible, les actions sont profondes et pionnières.
                </div>
              </div>
            </div>
          </div>

          <div class="cta-center">
            <a class="btn-primary" href="#evergreen" @click.prevent="switchTabById('evergreen')">
              LE PROGRAMME EVERGREEN
            </a>
          </div>
        </section>
      </div>

      <div v-else-if="activeTab.id === 'evergreen'">
        <section class="eg-what">
          <h2 class="eg-title" :class="isMobile ? 'merriweather-reg-20' : 'merriweather-reg-26'">Qu’est-ce que<br /><span :class="isMobile ? 'merriweather-reg-26' : 'merriweather-reg-40'">le programme Evergreen ?</span></h2>
          <h4 class="text-center pb-4" :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-24'">Un soutien pour les projets qui font pousser le tourisme durable</h4>

          <div class="eg-paras">
            <p>
              Chez Hortense, nous croyons que chaque nuit passée dans un hébergement peut devenir une graine d’avenir.
              C’est dans cette vision que s’inscrit le programme Evergreen : un dispositif concret de soutien à des projets
              écologiques portés par nos hébergements partenaires, pour réduire leur empreinte environnementale et favoriser
              une transformation durable.
            </p>
            <p>
              Le programme Evergreen, c’est bien plus qu’un fonds, c’est un accompagnement opérationnel et financier.
              Hortense soutient activement ses partenaires dans la conception, le financement et la mise en œuvre de
              projets à fort impact environnemental, social et économique.
            </p>
          </div>
        </section>

        <section class="eg-finance">
          <div class="eg-finance-grid">
            <div>
              <h3 class="text-center" :class="isMobile ? 'merriweather-reg-20' : 'merriweather-reg-26'">Comment est financé<br /><span :class="isMobile ? 'merriweather-reg-26' : 'merriweather-reg-40'">le programme Evergreen ?</span></h3>
              <p style="font: normal normal normal 15px/24px Raleway;">
                Pour chaque réservation effectuée sur Hortense.green, 1% du tarif de la nuitée est automatiquement reversé
                au programme Evergreen.
              </p>

              <div class="eg-pill" style="font-family: Raleway; text-align: center;">
                <strong>BONNE NOUVELLE POUR LES VOYAGEURS – LE PRIX PAR NUIT NE CHANGE PAS !</strong>
                <p style="font: normal normal normal 15px/24px Raleway;"> C’est Hortense qui assume cette contribution, en prélevant cette part sur sa propre commission. </p>
              </div>

              <p style="font: normal normal normal 15px/24px Raleway;">
                Chaque séjour devient un geste concret de soutien aux initiatives locales. En réservant simplement leur
                hébergement, les voyageurs contribuent à un tourisme équitable, où les hôtes engagés sont justement
                rémunérés. Ce modèle solidaire, porté collectivement par Hortense, les hôtes et les voyageurs, favorise
                un impact direct sur les projets écologiques et la vie locale, transformant chaque escapade en un acte de
                participation active à la transition.
              </p>
            </div>

            <div class="eg-logo" aria-hidden="true">
              <img src="../../images/logo_evergreen.svg"/>
            </div>
          </div>
        </section>

        <section class="eg-types">
          <h2 class="eg-title" :class="isMobile ? 'merriweather-reg-20' : 'merriweather-reg-26'">Quel type de projets<br /><span :class="isMobile ? 'merriweather-reg-26' : 'merriweather-reg-40'">sont soutenus ?</span></h2>
          <p class="eg-intro" style="font: normal normal normal 15px/24px Raleway;">
            La sélection des projets Evergreen repose sur une vision globale du développement durable selon trois grandes dimensions :
          </p>

          <div class="eg-columns">
            <div class="eg-col">
                <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Picto_environnemental_evergreen.png"/>
              <h5>ENVIRONNEMENTALE</h5>
              <p style="font: normal normal normal 15px/24px Raleway;">
                Des projets concrets pour réduire l’empreinte écologique des hébergements (isolation, énergies renouvelables,
                gestion de l’eau et des déchets…)
              </p>
            </div>

            <div class="eg-col">
              <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/picto_sociale_evergreen.png"/>
              <h5>SOCIALE</h5>
              <p style="font: normal normal normal 15px/24px Raleway;">
                Des initiatives qui mobilisent des artisans et entreprises locales, et créent de l’emploi à l’échelle du
                territoire.
              </p>
            </div>

            <div class="eg-col">
              <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Picto_economique_evergreen.png"/>
              <h5>ÉCONOMIQUE</h5>
              <p style="font: normal normal normal 15px/24px Raleway;">
                Des projets qui assurent une activité pérenne, équitablement rémunérée, et bénéfique à long terme pour
                tous les acteurs.
              </p>
            </div>
          </div>

          <p style="font: normal normal normal 15px/24px Raleway; font-weight: 600;" class="eg-note raleway-semi-p15"><em>Un soutien complet pour faire éclore les bonnes idées</em></p>

          <ul style="font: normal normal normal 15px/24px Raleway;" class="eg-benefits">
            <li>Une aide financière dédiée</li>
            <li>Un accès facilité à un réseau de partenaires qualifiés</li>
            <li>Les conseils personnalisés de l’équipe Hortense, pour transformer les idées en actions durables</li>
          </ul>
        </section>

        <section class="eg-closing">
          <h2 class="eg-title" :class="isMobile ? 'merriweather-reg-26' : 'merriweather-reg-40'">Evergreen, c’est …</h2>
          <p style="font: normal normal normal 15px/24px Raleway;" class="eg-phrase">
            Un cercle vertueux, où chaque nuit réservée devient une force de changement, où chaque hébergement accompagné
            devient un acteur de transition, et où chaque voyageur devient un allié du vivant.
          </p>

          <!-- <div class="cta-center">
            <a class="btn-primary" href="#label" @click.prevent="switchTabById('label')">
              LE LABEL GREEN HOST
            </a>
          </div> -->
        </section>
      </div>

      <div v-else-if="activeTab.id === 'label'">
        <section class="gh-intro" style="padding-left: 10%; padding-right: 10%;">
          <div class="gh-intro-inner">
            <div class="gh-title">
              <h3  style="font: normal normal normal 24px/29px Merriweather;">Qu’est-ce que</h3>
              <h2 style="font: normal normal normal 40px/29px Merriweather;">Le label Green Host ?</h2>
              <p class="lead" style="font: normal normal normal 15px/24px Raleway;">
                Green Host est un label créé par Hortense pour valoriser l’engagement environnemental des
                hébergements touristiques. Il distingue les adresses de charme qui allient respect de la nature,
                qualité de service et art de vivre.
              </p>
              <p class="lead" style="font: normal normal normal 15px/24px Raleway;">
                À travers ce label, Hortense souhaite fédérer ses partenaires autour des valeurs du développement
                durable, faciliter l’identification des hébergements éco-responsables par les voyageurs et rendre
                visible le niveau d’engagement de chaque établissement.
              </p>
            </div>
            <div class="gh-stamp" aria-hidden="true">
                <img class="stamp-svg" src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Label-d903dc26efd382b1b0d51cfa3ed3663d.svg"/>              
            </div>
          </div>
        </section>

        <section class="gh-mission">
          <h3 style="font-family: Merriweather;">Mission de Green Host</h3>
          <p class="sub"  style="font: normal normal normal 15px/24px Raleway;">La mission de Green Host est double :</p>
          <ul class="dot-list"  style="font: normal normal normal 15px/24px Raleway;">
            <li>Créer une communauté engagée d’hébergements qui partagent une vision durable du tourisme.</li>
            <li>Devenir une référence de confiance pour les voyageurs exigeants à la fois qualité et respect de l’environnement.</li>
          </ul>
          <p class="foot"  style="font: normal normal normal 15px/24px Raleway;">
            Green Host incarne ainsi l’alliance de l’excellence hôtelière et de la responsabilité environnementale.
          </p>
        </section>

        <section class="gh-criteria">
          <h3 style="font-family: Merriweather;">Critères d’obtention du label Green Host</h3>

          <div class="criteria-ribbon">
            <div class="criteria-left">
              <p style="font-family: Raleway;">
                Avoir obtenu un <strong><em>score supérieur à 5/10 à la GREEN NOTE,</em></strong>
                confirmé par un audit sur site réalisé par l’équipe Hortense
              </p>
            </div>

            <div class="criteria-or" aria-hidden="true">
              <span>—&nbsp;ou&nbsp;—</span>
            </div>

            <div class="criteria-right">
              <p><strong>Être en possession</strong> d’un des labels suivant</p>

              <div class="badge-row" aria-hidden="true">
                <img class="badge-svg" src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Logo_la_clef_verte.png"/>

                <img class="badge-svg" src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Logo_green_globe.png" />
                <img class="badge-svg" src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/eco-label-logo-1-removebg-preview%402x.png" />
              </div>
            </div>
          </div>
        </section>

        <section class="gh-values" style="font-family: Merriweather;">
          <h3>Les valeurs distinguées par le Label touristique Green Host</h3>

          <p class="sub" style="font: normal normal normal 15px/24px Raleway;">
            Les hébergements sélectionnés par Green Host se distinguent par leur capacité à :
          </p>

          <ul class="line-list" style="font: normal normal normal 15px/24px Raleway;">
            <li>Réduire efficacement leur impact environnemental</li>
            <li>Promouvoir une approche raffinée de l’art de vivre</li>
            <li>Offrir un cadre élégant, authentique et accueillant</li>
            <li>
              Proposer des chambres, suites ou lodges associant harmonieusement élégance et modernité.
            </li>
            <li>
              Se situer dans des environnements naturels ou patrimoniaux d’exception
            </li>
          </ul>
        </section>
      </div>
      <div v-else-if="activeTab.id === 'parrainage'">
        <section class="parr-hero">
          <div class="parr-hero-inner">
            <h2 class="text-center" :class="isMobile ? 'merriweather-reg-20' : 'merriweather-reg-26'">Partagez votre passion</h2>
            <h1 class="text-center" :class="isMobile ? 'merriweather-reg-26' : 'merriweather-reg-40'">pour le voyage durable</h1>
            <p class="text-center" :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-24'">
              Invitez vos proches à découvrir Hortense et profitez de privilèges exclusifs
            </p>

            <div class="parr-hero-card"
                :style="{'--hero-bg': `url(${isMobile ? heroMob : heroDesk})`}">
              <div class="parr-hero-card__veil">
                <p class="raleway-reg-p15 card-copy">
                  Hortense célèbre le voyage éthique et responsable et récompense, grâce à son programme
                  de parrainage, ceux qui partagent cette même vision. Invitez vos proches à rejoindre
                  le <em>Club Hortense</em> et, en retour, bénéficiez <strong>10% de réduction</strong>
                  sur votre prochain séjour et <strong>50 points</strong> de plus sur votre statut Club Hortense.
                </p>
                <button class="btn-primary parr-cta text-uppercase" @click="openSignup">Créer un compte client</button>
              </div>
            </div>
          </div>
        </section>

        <section class="parr-how">
          <h3 class="parr-how__title raleway">COMMENT ÇA MARCHE ? C’EST SIMPLE !</h3>

          <div class="parr-how__grid">
            <ol class="parr-steps">
              <li>
                <div class="dot">1</div>
                <div class="copy">
                  <div class="h raleway-bold">Invitez vos proches</div>
                  <p class="raleway-reg-p15">
                    Envoyez-leur votre lien de parrainage unique depuis votre espace personnel.
                  </p>
                </div>
              </li>
              <li>
                <div class="dot">2</div>
                <div class="copy">
                  <div class="h raleway-bold">Votre filleul s’inscrit</div>
                  <p class="raleway-reg-p15">
                    Dès son inscription, votre filleul reçoit <strong>100 points</strong> de fidélité
                    et vous gagnez <strong>50 points</strong> pour chaque nouvel inscrit.
                  </p>
                </div>
              </li>
              <li>
                <div class="dot">3</div>
                <div class="copy">
                  <div class="h raleway-bold">Ils réservent, vous en profitez</div>
                  <p class="raleway-reg-p15">
                    Dès que votre filleul effectue sa première réservation, vous obtenez un code
                    <strong>réduction de 10 %</strong> valable sur votre prochain séjour.
                  </p>
                </div>
              </li>
            </ol>
            <aside class="parr-card glass">
              <!-- <h4 class="parr-card__title merri">Parrainer un proche</h4>
              <p class="parr-card__sub raleway">
                Invitez vos proches à découvrir Hortense et bénéficiez d’avantages exclusifs
              </p> -->

              <div class="parr-video-wrap">
                <video class="parrainage-video" autoplay muted loop playsinline>
                  <source src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/comment-parrainer-un-proche-hortense-desktop.mp4" type="video/mp4" media="(min-width: 768px)" />
                  <source src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/comment-parrainer-un-proche-hortense-mobile+4.mp4"  type="video/mp4" media="(max-width: 767px)" />
                  Votre navigateur ne prend pas en charge la vidéo HTML5.
                </video>

              </div>

              <!-- <button class="btn-primary parr-cta mt-2">JE PARRAINE MON PROCHE</button> -->
            </aside>
          </div>

          <p class="parr-how__note raleway-reg-p15">
            Et c’est illimité ! Parrainez autant de proches que vous le souhaitez et cumulez vos avantages sans restriction.
          </p>
        </section>

        <section class="parr-advantages">
          <h3 class="sr-only">Les avantages</h3>
          <div class="parr-adv-grid">
            <article class="adv glass">
              <h4 class="merri adv-title">Pour vous</h4>
              <ul class="raleway">
                <li>50 points de fidélité offerts pour chaque filleul inscrit.</li>
                <li>10 % de réduction sur votre prochain séjour, dès que votre filleul effectue sa première réservation.</li>
              </ul>
            </article>

            <article class="adv glass">
              <h4 class="merri adv-title">Pour votre filleul</h4>
              <ul class="raleway">
                <li>100 points de fidélité offerts à l’inscription.</li>
                <li>10% de réduction sur leur première réservation.</li>
              </ul>
            </article>
          </div>
        </section>

        <section class="parr-realtime">
          <h3 class="rt-title raleway">SUIVEZ VOS RÉCOMPENSES EN TEMPS RÉEL</h3>
          <div class="rt-grid">
            <div class="rt-img">
              <picture>
                <source :srcset="rtMob" media="(max-width: 768px)"/>
                <img :src="rtDesk" alt="Espace client — suivi des points et parrainage"/>
              </picture>
            </div>
            <div class="rt-copy raleway">
              Dans votre espace personnel, vous pouvez suivre l’évolution de vos filleuls et les avantages que vous cumulez
              sous l’onglet <strong>Mon compte —&gt; Parrainage</strong>. Un seul geste et de belles récompenses à la clé !
            </div>
          </div>
        </section>

        <section class="parr-faq">
          <h3 class="faq-title" :class="isMobile ? 'merriweather-reg-26' : 'merriweather-reg-32'">Questions fréquentes<br/><span :class="isMobile ? 'merriweather-reg-26' : 'merriweather-reg-40'">sur le programme de parrainage</span></h3>

          <div class="gn-accordion parr-accordion">
            <div v-for="(q,i) in parrFaq" :key="i" class="acc-item">
              <button class="acc-head" @click="toggleAccParr(i)">
                <span class="raleway-semi-p15">{{ q.q }}</span>
                <svg :class="{ open: openFaq.includes(i) }" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M7 10l5 5 5-5" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <transition name="acc">
                <div v-show="openFaq.includes(i)" class="acc-panel">
                  <div class="raleway" v-html="q.a"></div>
                </div>
              </transition>
            </div>
          </div>
        </section>

        <section class="parr-bottom"
                :style="{'--bottom-bg': `url(${isMobile ? bottomMob : bottomDesk})`}">
          <div class="parr-bottom__veil">
            <p class="text-center text-white" :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-24'">
              Invitez dès maintenant vos proches et commencez à cumuler des avantages pour vos futurs séjours !
            </p>
            <button class="hortense-btn-primary parr-cta" @click="openSignup">Créer un compte client</button>
            <span class="link-hortense parr-cta-link" style=" text-decoration: underline;" @click="openLogin"> me connecter</span>
          </div>
        </section>
      </div>


      <div v-else class="placeholder">
        {{ activeTab.label }} — contenu à venir
      </div>
    </section>
    <Modalsignup v-if="showModal" :showModalLogin="showModalLogin" @close="onSignupClose" />
  </div>
</template>

<script>
import HortensioTwo from './HortensioTwo.vue';
import Modalsignup from '../modals/Modalsignup.vue';

export default {
  name: 'everGreen',
  props: {
    initialTab: { type: String, default: 'qui' },
    user: null
  },
  components: { HortensioTwo, Modalsignup },
  data() {
    return {
      showModal: false,
      activeTabId: this.initialTab,
      showModalLogin: false,
      isMobile: window.innerWidth <= 768,
      openFaq: [],
      parrFaq: [
  {
    q: "Qui peut participer au programme de parrainage ?",
    a: `
      Le programme est ouvert à tous les membres inscrits sur la plateforme Hortense.
      Si vous avez déjà un compte, vous pouvez inviter vos proches directement depuis votre
      espace personnel.
    `
  },
  {
    q: "Mes avantages sont-ils cumulables avec d’autres offres ?",
    a: `
      Non, les avantages obtenus via le programme de parrainage (réductions et points de fidélité)
      ne peuvent pas être combinés avec d’autres offres promotionnelles en cours.
    `
  },
  {
    q: "Combien de temps ma réduction de -10 % reste-t-elle valable ?",
    a: `
      La réduction de 10&nbsp;% est utilisable une seule fois, pour une prochaine réservation sur la
      plateforme. Elle n’est pas transférable à une autre personne.
    `
  },
  {
    q: "Quand les points de fidélité sont-ils crédités ?",
    a: `
      <p>Les points sont crédités automatiquement sur votre compte&nbsp;:</p>
      <ul>
        <li><strong>50 points</strong> pour le parrain dès que le filleul s’inscrit.</li>
        <li><strong>100 points</strong> pour le filleul au moment de son inscription.</li>
      </ul>
      <p>Tout se fait sans action de votre part&nbsp;!</p>
    `
  },
  {
    q: "Où puis-je suivre mes filleuls et mes récompenses ?",
    a: `
      Depuis votre espace personnel, rubrique <strong>Mon compte &rarr; Parrainage</strong>, vous pouvez
      consulter la liste de vos filleuls et le total de vos points de fidélité et réductions obtenus.
    `
  }
],
      heroDesk: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/section-1-programme-parrainage-hortense-desktop.webp",
      heroMob:  "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/section-1-programme-parrainage-hortense-mobile.webp",
      rtDesk:   "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/espace-client-parrainage-Hortense-dp.webp",
      rtMob:    "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/espace-client-parrainage-mb.webp",
      bottomDesk:"https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/section-3-programme-parrainage-hortense-desktop.webp",
      bottomMob: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/section-3-programme-parrainage-hortense-mobile.webp",
      videoDeskMp4: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/comment-parrainer-un-proche-hortense-desktop.mp4",
      videoMobMp4:  "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/comment-parrainer-un-proche-hortense-mobile.mp4",
      tabs: [
        {
          id: 'qui',
          label: 'QUI EST HORTENSE ?',
          title: 'Qui est Hortense ?',
          href: '/qui-est-hortense',
          image:
            'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/La_green_note_banner.webp',
        },
        {
          id: 'fondatrice',
          label: 'LE MOT DE LA FONDATRICE',
          title: 'Le mot de la Fondatrice',
          href: '/le-mot-de-la-fondatrice',
          image:
            'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Le_mot_de_la_fondatrice_banner.webp',
        },
        {
          id: 'club',
          label: 'LE CLUB HORTENSE',
          title: 'Le Club Hortense',
          href: '/le-club-hortense',
          image:
            'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Slider-ClubHortense.jpg',
        },
        {
          id: 'parrainage',
          label: 'LE PROGRAMME DE PARRAINAGE',
          title: 'Le programme de parrainage',
          href: '/programme-de-parrainage',
          image: 'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Le_programme_Evergreen_banner.webp',       
        },
        {
          id: 'green',
          label: 'LA GREEN NOTE',
          title: 'La Green Note',
          href: '/la-green-note',
          image:
            'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/La_green_note_banner.webp',
        },
        {
          id: 'evergreen',
          label: 'LE PROGRAMME EVERGREEN',
          title: 'Le Programme Evergreen',
          href: '/programme-evergreen',
          image:
            'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Le_programme_Evergreen_banner.webp',
        },
        // {
        //   id: 'label',
        //   label: 'LE LABEL GREEN HOST',
        //   title: 'Le Label Green Host',
        //   image:
        //     'https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Le_label_green_host_banner.webp',
        // },
      ],
      activeTab: null,

      petalColors: ['#2f6b57', '#3a7a63', '#4b9b7a', '#94c8a5', '#cfdcc8', '#e7eeda'],
      criteria: [
        {
          title: 'Politique et gestion environnementale',
          points: [
            'Mettre en place une politique environnementale claire et écrite',
            'Identifier les zones de gaspillage',
            'Identifier les axes d’amélioration',
            'Définir des plans d’actions à court, moyen et long terme',
          ],
        },
        {
          title: 'Responsabilité sociale',
          points: [
            'Instaurer un dialogue social',
            'Établir des solutions d’amélioration des conditions de travail',
            'Évaluer son empreinte carbone',
            'Mettre en place des mesures correctives'
          ],
        },
        {
          title: 'Formation du personnel',
          points: [
            'Nommer un responsable de la gestion environnementale',
            'Fédérer les équipes autour du développement durable',
            'Former les salariés aux éco-gestes et aux bonnes pratiques de gestion durable',
            'Organiser des réunions sur les questions environnementales'
          ],
        },
        {
          title: "Gestion de l'énergie",
          points: [
            'Mettre en place un suivi de la consommation',
            'Mettre en place une isolation thermique efficace',
            'Diminuer la consommation d’énergie par nuitée',
            'Augmenter la part des énergies renouvelables'
          ],
        },
        {
          title: 'Sensibilisation des clients',
          points: [
            'Information des clients sur la politique environnementale de l’hébergement',
            'Proposer des activités respectueuses de l’environnement.',
            'Afficher les éco-gestes',
            'Informer les clients sur les modes de transport les moins polluants pour leurs déplacements'
          ],
        },
        {
          title: 'Gestion des déchets',
          points: [
            'Tri et recyclage des déchets',
            'Réduction des volumes de déchets à la source',
            'Réutilisation des déchets produits et recherche d’utilisations alternatives',
            'Offrir les surplus alimentaires à des organismes de charité'
          ],
        },
        {
          title: "Gestion de l’eau",
          points: [
            'Mettre en place un suivi de la consommation',
            'Réduire la consommation d’eau par nuitée',
            'Collecter et traiter les eaux usées',
            'Réduire la pollution'
          ],
        },
        {
          title: 'Achats responsables',
          points: [
            'Acheter des produits (alimentation, entretien, papeterie, mobilier, autres achats) en circuit court',
            'Privilégier les produits biologiques/durables et de saison',
            'Privilégier les emballages recyclables',
            'Éviter les emballages individuels'
          ],
        },
        {
          title: 'Environnement extérieur et intérieur',
          points: [
            'Aménager des espaces verts',
            'Entretenir les espaces verts',
            'Ne pas utiliser de produits chimiques polluants',
            'Limiter le tabagisme dans les espaces communs et dans les chambres'
          ],
        },
        {
          title: 'Éco-construction',
          points: ['Favoriser les constructions et les rénovations durables (label HQE)', 'Améliorer l’intégration paysagère des hébergements', "Privilégier la plantation d'espèces végétales locales",'Mettre en place des systèmes de production d’énergie renouvelable'],
        },
      ],
      openAcc: [0],
    };
  },
  created() {
  if (this.initialTab) {
    const m = this.tabs.find(t => t.id === this.initialTab);
    if (m) { this.activeTab = m; return; }
  }

  const path = window.location.pathname.replace(/\/+$/, ''); 
  const m2 = this.tabs.find(t => t.href === path || t.path === path);
  if (m2) { this.activeTab = m2; return; }

  this.activeTab = this.tabs[0];
  this.onResizeParr();
  window.addEventListener('resize', this.onResizeParr, { passive: true });
},
beforeDestroy() {
  window.removeEventListener('resize', this.onResizeParr);
},
computed: {
    videoDesktop() {
      return ('../../images/comment-parrainer-un-proche-hortense-desktop.mp4')
    },
    videoMobile() {
      return ('../../images/comment-parrainer-un-proche-hortense-mobile-2.mp4')
    }

  },
  methods: {
    openSignup() {
      this.showModal = true;
      this.showModalLogin = false
    },
    openLogin() {
      this.showModalLogin = true
      this.showModal = true;
    },
    onSignupClose(user) {
      this.showModal = false;
    },
    onResizeParr() {
    this.isMobile = window.innerWidth <= 768;
  },
  toggleAccParr(i) {
    this.openFaq = this.openFaq.includes(i)
      ? this.openFaq.filter(x => x !== i)
      : [...this.openFaq, i];
  },
    switchTab(tab) {
  if (this.activeTab.id !== tab.id) {
    // navigate to the canonical URL for this tab (triggers full reload)
    window.location.href = tab.href; // e.g. '/la-green-note'
  }
},
switchTabById(id) {
  const t = this.tabs.find(x => x.id === id);
  if (t) this.switchTab(t);
},
    toggleAcc(idx) {
      this.openAcc = this.openAcc.includes(idx)
        ? this.openAcc.filter((i) => i !== idx)
        : [...this.openAcc, idx];
    },
  },
};
</script>

<style scoped>
.banner {
  background-size: cover;
  background-position: center;
  height: 400px !important;
  position: relative;
}
.overlay {
  background: rgba(0, 0, 0, 0.30);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.overlay h1 {
  color: #fff;
  font-family: 'Merriweather', serif;
  font-weight: 400;
  font-size: 40px;
  text-align: center;
  line-height: 1.15;
  padding: 0 1rem;
}

.tabs {
  background: #000;
  color: #fff;
  padding: 12px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.tabs ul {
  list-style: none;
  margin: 0;
  padding: 0 16px;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 18px;
  scrollbar-width: thin;
}
.tabs li {
  white-space: nowrap;
  opacity: 0.85;
  cursor: pointer;
  padding: 8px 2px;
  font-weight: 700;
  border-bottom: 2px solid transparent;
}
.tabs li.active {
  border-bottom-color: #fff;
  opacity: 1;
}

.tabs {
  background:#000;
  color:#fff;
}
.tabs ul{
  display:flex;
  flex-wrap:wrap;
  align-items:center;
  margin:0;
  padding:8px 16px; 
  list-style:none;
}
.tabs .tab-item{
  font: normal normal bold 15px/18px Raleway;
  cursor:pointer;
  padding:8px 0;   
  white-space:nowrap;
  position:relative;
}

.tabs .tab-item.active{
  border-bottom:2px solid #fff;
}

.tabs .tab-item + .tab-item::before{
  content:"";
  display:inline-block;
  width:1px;    
  height:12px;          
  background:#fff;
  margin:0 10px;          
  vertical-align:middle;
}


.content {
  margin: 70px auto;
  padding: 0 20px;
}

.intro h2 {
  margin-bottom: 22px;
  line-height: 1.2;
}
.intro h2 span {
  color: #2f7744;
}
.text-image {
  display: grid;
  grid-template-columns: 460px 1fr;
  gap: 15%;
  align-items: start;
}
.text-image .media {
  width: 40vw;
  height: 383px;
  object-fit: cover;
  max-width: 600px;
}
.text p {
  color: black;
  margin-bottom: 12px;
  font: normal normal normal 15px/24px Raleway;
}

.mv-grid .block + .block {
  margin-top: 30px;
}
.block{
  display:flex;
  flex-direction:column;
  margin-top: 30px;
}
.mv-grid{
  max-width: 1200px  !important; margin: 70px auto !important; padding: 0 20px  !important;
  margin:0 auto;
  display:grid;
  grid-template-columns: repeat(2, minmax(0,1fr));
  column-gap:48px;
  row-gap:0;
}
.mv-grid h2 {
  font-size: 2rem;
  margin-bottom: 20px;
}
.cards {
  display: grid;
  gap: 26px;
}
.card {
  border: none !important;
  background: transparent;
  background-color: transparent;
}
.card img {
  width: 100%;
  height: 220px;
  object-fit: cover;
}
.card h3 {
  margin: 14px 0 8px;
  font-weight: bold;
  font: normal normal bold 16px/25px Raleway;
}
.card p {
  color: #454545;
  line-height: 1.7;
  font: normal normal normal 15px/24px Raleway;
}

.founder-essay p {
  font: normal normal normal 15px/24px Raleway;
  color: #363636;
  text-align: center;
  margin: 0 0 18px;
  padding-left: 10%;
  padding-right: 10%;
  text-align: center;

}
.founder-quote {
  padding: 46px 150px;
  border-radius: 14px;
  display: grid;
  grid-template-columns: 1fr 420px;
  gap: 10px;
  align-items: center;
}
.founder-quote blockquote {
  margin: 0 0 18px 0;
  font-style: italic;
  color: #2a2a2a;
  line-height: 1.9;
  text-align: center;
}
.signature {
  text-align: center;
}
.signature .name {
  margin-top: 6px;
  font: normal normal normal 30px/30px Abuget;
}
.signature .role {
  color: #5c6a63;
  font: italic normal normal 16px/30px Raleway;
}
.founder-photo img {
  width: 100%;
  height: 340px;
  object-fit: cover;
  display: block;
}

.cta-center {
  text-align: center;
  margin-top: 36px;
}
.btn-primary {
  display: inline-block;
  background: #3B6152;
  color: #fff;
  padding: 12px 22px;
  text-decoration: none;
  font-family: 'Raleway';
  font-weight: 700;
  font-size: 13px;
  border-color: unset;
}
a.btn-primary,
a.btn-primary:visited {
  background: #3B6152;
  color: #fff;
  border: none;
  box-shadow: none;
}

a.btn-primary:focus,
a.btn-primary:active {
  background: #3B6152 !important;
  color: #fff !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.btn-primary:hover {
  background: #3B6152;
    color: white;
  }

.gn-intro h2 { line-height: 1.15; margin-bottom: 12px; }
.gn-intro .lead { max-width: 980px; margin: 0 auto;  color: #2b2b2b; font: normal normal normal 15px/24px Raleway; }

.gn-ambition { background: #f1f7f3; border-radius: 14px; margin: 54px 0 28px; padding: 28px 18px; }
.ambition-inner { display: grid; grid-template-columns: 360px 1fr; gap: 30px; align-items: center; max-width: 1100px; margin: 0 auto; }
.gn-logo img { width: 100%; height: auto; }
.ambition-copy h3 { line-height: 1.2; margin: 0 0 10px; }
.ambition-copy p { color: #2f3b34; font: normal normal normal 15px/24px Raleway; }

.gn-how { margin-top: 40px; }
.gn-how h3 { line-height: 1.2; margin-bottom: 10px; text-align:center;}
.how-lead, .how-foot { font: normal normal normal 15px/24px Raleway; max-width: 1050px; margin: 18px auto;  color: #2d2d2d; text-align: center; }
.gn-accordion { background: #f7f6f3; border-radius: 12px; padding: 20px; margin: 28px auto 16px; max-width: 1100px; }
.acc-title { font-size: 1.6rem; text-align: center; margin-bottom: 10px; font-family: Merriweather; }
.acc-item + .acc-item { border-top: 1px solid #dcdcd2; }
.acc-head { width: 100%; background: transparent; border: none; padding: 16px 6px; display: flex; align-items: center; justify-content: space-between; font-weight: 700; color: #2c5c49; cursor: pointer; }
.acc-head svg { transition: transform .25s ease; }
.acc-head svg.open { transform: rotate(180deg); }
.acc-panel { padding: 0 6px 16px 6px; }
.acc-panel ul { margin: 0; font-family: Raleway; padding-left: 18px; }
.acc-panel li { line-height: 1.8; font-family: Raleway; color: #39423d; }

.gn-levels { margin-top: 64px; }
.levels-title { font-family: Merriweather; margin-bottom: 26px; }
.levels-track { position: relative; height: 90px; margin: 0 10px 10px; }
.levels-track .track-line { position: absolute; left: 5%; right: 1%; top: 58px; height: 12px; border-radius: 10px; background: linear-gradient(90deg,#b7dbc7,#6aae95); }
.levels-track .pins { position: absolute; left: 5%; right: 1%; top: 0; display: grid; grid-template-columns: repeat(4,1fr); justify-items: center; align-items: start; }
.pin { width: 42px; height: 52px; display: inline-block; }
.pin img { width: 100%; height: 100%; }
.levels-grid { padding-left: 2%; padding-left: 5%; display: grid; grid-template-columns: repeat(4,1fr); gap: 28px; margin-top: 6px; }
.level-col { display: grid; grid-template-rows: auto auto; gap: 22px; }
.pill { border-radius: 8px; box-shadow: 0 8px 16px rgba(25, 69, 52, 0.18); }
.pill-top { text-align: center; font-weight: 800; color: #0b2a1f; }
.pill-top .pill-inner {text-transform: uppercase; padding: 18px 12px; font-family: Merriweather; }
.pilll {text-transform: uppercase;}
.tone-1 { background: #B5DABB; }
.tone-2 { background: #B5DABB; }
.tone-3 { background: #7DCEAE; }
.tone-4 { background: #4E8E74; color: #0a241b; }
.pill-bottom { background: #f1f7f3; }
.pill-bottom .pill-inner { padding: 18px 16px; color: #2f3b34; line-height: 1.7; font-family: Raleway }

.acc-enter-active, .acc-leave-active { transition: height .22s ease, opacity .22s ease; }
.acc-enter, .acc-leave-to { height: 0; opacity: 0; }

.eg-what { text-align:center; }
.eg-title {  margin-bottom: 4px; }
.eg-sub { font: normal normal normal 22px/28px Raleway; margin-bottom: 18px; }
.eg-paras { max-width: 1100px; margin: 0 auto; font: normal normal normal 15px/24px Raleway; }
.eg-paras p { font: normal normal normal 15px/24px Raleway; color:#222; margin-bottom: 12px; }

.eg-finance { background:#CFE5DC33; border-radius: 16px; padding: 28px 24px; margin-top: 28px; }
.eg-finance-grid { display:grid; grid-template-columns: 1fr 360px; gap: 24px; align-items:center; max-width:1100px; margin:0 auto; }
.eg-finance h3 { margin: 0 0 8px; }
.eg-finance p { font: normal normal normal 15px/24px Raleway; color:#222; }
.eg-pill { background:#cfe5dc; border-radius: 20px 20px 0px 20px; padding: 14px 16px; margin: 10px 0 12px; }
.eg-pill strong { display:block; margin-bottom: 6px; }
.eg-logo img { width: 100%; height: auto; }

.eg-types { text-align:center; margin-top: 38px; }
.eg-intro { max-width: 980px; margin: 10px auto 18px; font: normal normal normal 15px/24px Raleway; }
.eg-columns { display:grid; grid-template-columns: repeat(3,1fr); gap: 22px; max-width:1100px; margin: 0 auto; }
.eg-col { background:#f7fbf8; border-radius: 12px; padding: 18px 16px;  }
.eg-ico { width: 56px; height: 56px; margin: 0 auto 8px; background:#2f6b57; border-radius: 50%; position:relative; }
.eg-ico.leaf { position:absolute; inset:14px; border-radius: 50% 0; background: transparent; transform: rotate(45deg); }
.eg-ico.hands:after { content:''; position:absolute; left:14px; right:14px; bottom:14px; top:28px; background:#eaf6ef; border-radius: 0 0 16px 16px; }
.eg-ico.coin:after { content:'$'; position:absolute; left:0; right:0; top:6px; text-align:center; font-weight:700; color:#eaf6ef; font-family:Raleway; }
.eg-col h5 { font: normal normal bold 14px/20px Raleway; letter-spacing:.5px; margin: 6px 0; }
.eg-col p { font: normal normal normal 14px/22px Raleway; color:#2d2d2d; }

.eg-note { margin: 16px auto 6px; font: italic normal normal 15px/22px Raleway; }
.eg-benefits { max-width: 900px; margin: 8px auto 0; font: normal normal normal 15px/24px Raleway; text-align:left; }
.eg-benefits li { margin: 6px 0; }

.eg-closing { text-align:center; margin-top: 38px; }
.eg-phrase { max-width: 1200px; margin: 8px auto 18px; font: normal normal normal 18px/28px Raleway; }

.gh-intro { margin-top: 10px; }
.gh-intro-inner { display: grid; grid-template-columns: 1fr 420px; align-items: center; gap: 32px; }
.gh-title h3 { font-size: 2rem; text-align: center; margin: 0; }
.gh-title h2 { font-size: 3rem; text-align: center; margin: 6px 0 16px; }
.gh-title .lead { line-height: 1.9; color: #2b2b2b; margin: 10px 0; }
.gh-stamp { display: flex; align-items: center; justify-content: center; }
.stamp-svg { width: 340px; height: 340px; transform: rotate(-20deg); }

.gh-mission { margin-top: 36px; text-align: center; }
.gh-mission h3 { font-size: 2rem; margin-bottom: 8px; }
.gh-mission .sub { color: #2b2b2b; }
.dot-list { max-width: 950px; margin: 12px auto; text-align: center; list-style: none; padding: 0; }
.dot-list li { margin: 6px 0; }
.gh-mission .foot { margin-top: 12px; }

.gh-criteria { margin-top: 34px; }
.gh-criteria h3 { font-size: 2rem; text-align: center; margin-bottom: 18px; }
.criteria-ribbon { background: #e9f3ee; border-radius: 16px; padding: 22px 22px; display: grid; grid-template-columns: 1fr auto 1fr; gap: 16px; align-items: center; box-shadow: 0 4px 16px rgba(20, 62, 44, 0.08); }
.criteria-left p, .criteria-right p { margin: 0; line-height: 1.6; }
.criteria-left strong em { font-weight: 800; }
.criteria-or span { color: #6c7a72; font-weight: 700; }
.badge-row { display: flex; gap: 14px; margin-top: 10px; flex-wrap: wrap; }
.badge-svg { width: 80px; height: 80px; }

.gh-values { margin-top: 34px; text-align: center; }
.gh-values h3 { font-size: 2rem; margin-bottom: 10px; }
.gh-values .sub { color: #2b2b2b; }
.line-list { max-width: 980px; margin: 16px auto 0; text-align: left; list-style: none; padding-left: 0; }
.line-list li { padding: 10px 0; border-bottom: 1px solid #dfe8e3; }

.placeholder { text-align: center; color: #666; padding: 120px 0; }

@media (max-width: 768px) {
  .overlay h1 { 
    font-family: 'Merriweather', serif;
    font-weight: 400;
    font-size: 32px; 
  }
}
@media (max-width: 1024px) {
  .text-image { grid-template-columns: 1fr; }
  .text-image .media { height: 300px; }
  .cards { grid-template-columns: 1fr; }
  .founder-quote { grid-template-columns: 1fr; }
  .founder-photo img { height: 320px; }

  .gn-ambition .ambition-inner { grid-template-columns: 1fr; }
  .levels-grid { grid-template-columns: repeat(2,1fr); gap:22px; }

  .eg-finance-grid { grid-template-columns: 1fr; }
  .eg-columns { grid-template-columns: 1fr; }

  .gh-intro-inner { grid-template-columns: 1fr; }
  .stamp-svg { width: 300px; height: 300px; }
  .criteria-ribbon { grid-template-columns: 1fr; text-align: center; }
  .criteria-or { order: 2; }
  .criteria-right { order: 3; }
}
@media (max-width: 640px) {
  .banner { height: 52vh; }
  .content { margin: 40px auto; }
  .intro h2 { font-size: 1.7rem; }
  .founder-essay p { font-size: 1rem; text-align: left; }
  .founder-quote { padding: 26px 18px; gap: 18px; }
  .tabs ul { gap: 14px; }
  .tabs li { font-size: 0.92rem; padding-bottom: 6px; }

  .levels-track { height: 70px; }
  .levels-track .track-line { top: 44px; }
  .pin { width: 34px; height: 42px; }
  .levels-grid { grid-template-columns: 1fr; gap: 18px; }

  .eg-title { line-height: 40px; }
  .eg-phrase { font-size: 16px; line-height: 26px; }

  .gh-title h2 { font-size: 2.2rem; }
  .stamp-svg { width: 260px; height: 260px; }
}
.ma-header {
      text-align: center;
      margin-bottom: 1.75rem;
      .kicker { margin: 0 0 .25rem; }
      .title  { margin: 0; line-height: 1.15; }
    }
@media (max-width: 1024px){
  .intro{ margin: 40px auto !important; padding: 0 24px !important; }
  .mv-grid{ padding: 0 24px !important; }
}

@media (max-width: 768px){
  .ma-header{ text-align:center; }
  .ma-header .kicker{ margin: 0 0 4px; }
  .ma-header .title{ margin: 0; }

  .intro{ margin: 30px auto !important; padding: 0 16px !important; }

  .text-image{
    display: grid;
    grid-template-columns: 1fr;
    gap: 18px;
    align-items: start;
  }
  .text-image .media{
    width: 100%;
    max-width: 100%;
    height: auto;          
    object-fit: cover;
    display: block;
  }
  .text p{ font: normal normal normal 15px/24px Raleway; }

  .mv-grid{
    margin: 34px auto !important;
    padding: 0 16px !important;
    display: grid;
    grid-template-columns: 1fr;  
    row-gap: 32px;
    column-gap: 0;
    max-width: 100% !important;
  }
  .mv-grid .block + .block{ margin-top: 0; }

  .mv-grid h2{
    font: normal normal normal 28px/36px Merriweather !important;
    margin: 0 0 14px;
    text-align: left;
  }

  .cards{ display: grid; gap: 18px; }
  .card{ background: transparent; border: 0; }
  .card img{
    width: 100%;
    height: auto;        
    object-fit: cover;
    display: block;
  }
  .card h3{ font: normal normal bold 16px/24px Raleway; margin: 10px 0 6px; }
  .card p{  font: normal normal normal 15px/24px Raleway; }

  .founder-quote{
    padding: 22px 16px;
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .founder-photo img{ height: auto; }

  .ambition-inner{
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .levels-grid{ grid-template-columns: repeat(2, minmax(0,1fr)); gap: 16px; padding-left: 0; }
  .levels-track{ height: 72px; }
  .levels-track .track-line{ top: 48px; }
  .levels-track .pins{ top: 0; }
}

/* Very small phones */
@media (max-width: 480px){
  .ma-header .kicker{ font: normal normal normal 24px/32px Merriweather !important; }
  .ma-header .title{  font: normal normal normal 30px/38px Merriweather !important; }

  .mv-grid{ padding: 0 14px !important; }
  .card h3{ font: normal normal bold 15px/22px Raleway; }
  .card p{  font: normal normal normal 14.5px/23px Raleway; }
}

.merri { font-family: Merriweather, serif; }
.raleway { font-family: Raleway, sans-serif; }
.raleway-bold { font-family: Raleway, sans-serif; font-weight: 700; }
.merri.thin { font-weight: 400; }
.merri.huge { font-weight: 400; font-size: 42px; line-height: 1.1; text-align:center; margin: .2rem 0 1rem; }
.raleway.lead { line-height: 1.6; text-align:center; color:#222; font: normal normal normal 15px/24px Raleway;}

.parr-hero { padding-top: 34px; }
.parr-hero-inner { margin: 0 auto; padding: 0 20px; }
.parr-hero-inner h2 { text-align: center; margin: 0 0 .25rem; }

.parr-hero-card {
  --radius: 18px;
  background-image: var(--hero-bg);
  background-size: cover;
  background-position: center;
  border-radius: var(--radius);
  overflow: hidden;
  margin: 22px auto 0;
  min-height: 196px;
  box-shadow: 0 10px 24px rgba(0,0,0,.12);
}
.parr-hero-card__veil {
  background: rgba(0,0,0,.35);
  color: #fff;
  padding: 28px 20px;
  display: grid;
  place-items: center;
  text-align: center;
}
.parr-hero-card .card-copy {
  max-width: 90%;
  margin: 0 auto 16px;
  font-size: 15px;
  line-height: 1.7;
}
.parr-cta { margin-top: 6px; }

.parr-how { background: #f1f7f3; margin-top: 34px; padding: 24px 0 12px; }
.parr-how__title {font: normal normal 600 15px/24px Raleway; max-width: 1200px; margin: 0 auto; padding: 0 20px; font-weight: 800; letter-spacing:.3px; }

.parr-how__grid {
  max-width: 1200px; margin: 14px auto 0; padding: 0 20px;
  display: grid; grid-template-columns: 1fr 520px; gap: 28px; align-items: start;
}

/* Card that contains the video */
.parr-card.glass {
  background: #e7efe9;
  border: 1px solid #dfe9e4;
  border-radius: 16px;
  padding: 18px;
  box-shadow: 0 8px 26px rgba(32, 76, 58, .10);
}
.parr-card__title { font-size: 2rem; line-height: 1.2; text-align:center; margin: 8px 0 4px; }
.parr-card__sub { text-align:center; color:#2b3a34; margin-bottom: 12px; }
.parr-video-wrap{
  width: 100%;
  max-width: 980px;          
  margin: 0 auto;
  border-radius: 16px;
  overflow: hidden;
  background: #e8f2ed;       
  box-shadow: 0 12px 28px rgba(24,63,49,.12);
}

.parrainage-video{
  display: block;
  width: 100%;
  height: auto;               
  aspect-ratio: 16 / 9;       
  object-fit: contain;        
  object-position: center;    
  background: #e8f2ed;       
}

@media (min-width: 1024px){
  .parr-video-wrap{ max-width: 1100px; }
  .parrainage-video{ aspect-ratio: 16 / 9; }
}

@media (max-width: 767px){
  .parr-video-wrap{ border-radius: 12px; }
  .parrainage-video{ aspect-ratio: 9 / 16; }
}

.mt-2 { margin-top: 12px; }

/* Timeline */
.parr-steps { list-style: none; margin: 0; padding: 0; position: relative; }
.parr-steps li { display: grid; grid-template-columns: 56px 1fr; gap: 12px; padding: 16px 0; position: relative; }
.parr-steps li + li { border-top: 1px dashed #c9d8d2; }
.parr-steps .dot {
  width: 56px; height: 56px; border-radius: 50%;
  background: #3B6152; color: #fff; display: grid; place-items: center;
  font: 700 1.1rem Raleway, sans-serif;
}
.parr-steps .copy .h { font: normal normal 600 15px/24px Raleway; margin-bottom: 4px; }
.parr-steps .copy p { color:#22302b; line-height: 1.7; }

.parr-how__note { max-width: 1200px; margin: 10px auto 0; padding: 0 20px 16px; color:#2d2d2d; }

.parr-advantages { padding: 26px 0; }
.parr-adv-grid {
  max-width: 1200px; margin: 0 auto; padding: 0 20px;
  display: grid; grid-template-columns: repeat(2,1fr); gap: 22px;
}
.adv.glass { background: #ffffff; border: 1px solid #e7efe9; border-radius: 14px; padding: 18px; box-shadow: 0 6px 18px rgba(15, 55, 36, .08); }
.adv-title { font: normal normal 600 15px/24px Raleway;  margin: 0 0 8px; }
.adv ul { margin: 0; padding-left: 18px; line-height: 1.8; color:#2c2c2c; }

.parr-realtime { background: #eef6f2; padding: 26px 0 18px; }
.rt-title {font: normal normal 600 15px/24px Raleway; max-width: 1200px; margin: 0 auto 10px; padding: 0 20px; font-weight: 800; }
.rt-grid {
  max-width: 1200px; margin: 0 auto; padding: 0 20px;
  display: grid; grid-template-columns: 1fr 1fr; gap: 26px; align-items: center;
}
.rt-img img { width: 100%; height: auto; display: block; border-radius: 12px; box-shadow: 0 10px 24px rgba(0,0,0,.08); }
.rt-copy { color:#2b3a34; line-height: 1.8; }

.parr-faq { padding: 36px 0 10px; }
.faq-title { text-align: center; line-height: 1.2; }
.faq-title span { display:block; margin-top: 6px; }
.parr-accordion { max-width: 1200px; margin: 6px auto 0; }

.parr-bottom {
  --r: 18px;
  margin: 26px auto 0; max-width: 1200px; padding: 0 20px;
}
.parr-bottom__veil {
  background-image: var(--bottom-bg);
  background-size: cover; background-position: center;
  min-height: 210px; border-radius: var(--r);
  display: grid; place-items: center; text-align: center; position: relative; overflow: hidden;
}
.parr-bottom__veil::before {
  content: ""; position: absolute; inset: 0; background: rgba(0,0,0,.35);
}
.parr-bottom__veil > * { position: relative; z-index: 1; }
.bottom-copy { color: #fff; font-size: 1.05rem; line-height: 1.7; max-width: 720px; margin: 0 auto 8px; }

.sr-only { position:absolute; width:1px; height:1px; clip: rect(1px,1px,1px,1px); overflow:hidden; }

@media (max-width: 768px){
  .overlay { margin-top: 8rem; }
  .merri.huge { font-size: 30px; }
  .parr-hero-card { min-height: 220px; }

  .parr-how__grid { grid-template-columns: 1fr; gap: 16px; }
  .parr-card__title { font-size: 1.7rem; }
  .parr-steps li { grid-template-columns: 44px 1fr; }
  .parr-steps .dot { width: 44px; height: 44px; font-size: 1rem; }
  .parr-steps .copy .h { font-size: 1rem; }

  .parr-adv-grid { grid-template-columns: 1fr; }
  .rt-grid { grid-template-columns: 1fr; }

  .parr-bottom__veil { min-height: 200px; }
}

.parr-cta-link {
  color: white;
}
</style>